/**
 * Prefetch ảnh trước khi hiển thị để tránh delay
 * @param imageUrl - URL của ảnh cần prefetch
 * @returns Promise<boolean> - true nếu prefetch thành công, false nếu thất bại
 */
export const prefetchImage = (imageUrl: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!imageUrl || typeof imageUrl !== 'string') {
      resolve(false)
      return
    }

    const img = new Image()

    img.onload = () => {
      resolve(true)
    }

    img.onerror = () => {
      console.warn('Không thể prefetch ảnh:', imageUrl)
      resolve(false)
    }

    // Bắt đầu load ảnh
    img.src = imageUrl
  })
}

/**
 * Prefetch nhiều ảnh cùng lúc
 * @param imageUrls - Mảng các URL ảnh cần prefetch
 * @returns Promise<boolean[]> - Kết quả prefetch cho từng ảnh
 */
export const prefetchMultipleImages = (
  imageUrls: string[]
): Promise<boolean[]> => {
  const promises = imageUrls.map((url) => prefetchImage(url))
  return Promise.all(promises)
}
